import { c as _c } from "react/compiler-runtime";
import { getFormattedCurrency } from '@svs/nova-poolbetting/core/lib/client';
import type { SROW } from '@svs/nova-poolbetting/schema/coupon';
import type { WinDivisions } from '@svs/nova-poolbetting/schema/forecast';
import type { ReactNode } from 'react';
type WinDivisionsProps = {
  winDivisions: WinDivisions[];
  numberOfEvents: number;
  hasMaskedEvents?: boolean;
  bestBetRows?: SROW[][];
  shouldHideBackground?: boolean;
  isMarketplaceWager?: boolean;
};

/**
 * WinDivisions component.
 *
 * @param root0 props
 * @param root0.winDivisions win divisions data for draw
 * @param root0.numberOfEvents total number of events in the draw
 * @param root0.hasMaskedEvents indicates if there are masked outcomes in the draw
 * @param root0.bestBetRows best bet rows for wager
 * @param root0.shouldHideBackground indicates if background should be hidden
 * @param root0.isMarketplaceWager indicates if the wager is a marketplace wager
 * @returns The WinDivisions presentational component.
 */
export function WinDivisions(t0) {
  const $ = _c(20);
  const {
    winDivisions,
    numberOfEvents,
    hasMaskedEvents,
    bestBetRows,
    shouldHideBackground,
    isMarketplaceWager
  } = t0;
  const teamOrIndividual = isMarketplaceWager ? "lagets" : "dina";
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <th scope="col" className="text-left">Antal rätt</th>;
    t2 = <th scope="col" className="text-center">Utdelning</th>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  const t3 = !bestBetRows || hasMaskedEvents ? "" : ` (${teamOrIndividual})`;
  let t4;
  if ($[2] !== t3) {
    t4 = <thead className="text-layer-fg border-stroke-low border-b"><tr className="grid grid-cols-3 p-3">{t1}{t2}<th scope="col" className="text-right text-nowrap">Rätta rader{t3}</th></tr></thead>;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== bestBetRows || $[5] !== hasMaskedEvents || $[6] !== numberOfEvents || $[7] !== shouldHideBackground || $[8] !== winDivisions) {
    let t6;
    if ($[10] !== bestBetRows || $[11] !== hasMaskedEvents || $[12] !== numberOfEvents || $[13] !== shouldHideBackground) {
      t6 = division => {
        const hasWinRows = (bestBetRows?.[division.winDivision - 1]?.length ?? 0) > 0;
        return <tr className={`m-1.5 grid grid-cols-3 rounded-md p-1.5 ${hasWinRows && !shouldHideBackground ? "bg-success text-success-fg" : ""}`} key={division.winDivision}><td className="text-left">{numberOfEvents - (division.winDivision - 1)}</td><td className="text-center">{getFormattedCurrency(division.winValue)}</td><td className="text-right">{division.winners} st{bestBetRows && !hasMaskedEvents && bestBetRows[division.winDivision - 1]?.length !== undefined ? ` (${bestBetRows[division.winDivision - 1]?.length} st)` : undefined}</td></tr>;
      };
      $[10] = bestBetRows;
      $[11] = hasMaskedEvents;
      $[12] = numberOfEvents;
      $[13] = shouldHideBackground;
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    t5 = winDivisions.map(t6);
    $[4] = bestBetRows;
    $[5] = hasMaskedEvents;
    $[6] = numberOfEvents;
    $[7] = shouldHideBackground;
    $[8] = winDivisions;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[15] !== t5) {
    t6 = <tbody className="text-layer-fg-muted">{t5}</tbody>;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t4 || $[18] !== t6) {
    t7 = <table className="bg-surface-standard lg:text-md w-full rounded-md p-4 text-sm">{t4}{t6}</table>;
    $[17] = t4;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
}